import { render, staticRenderFns } from "./BaseCollapsibleBlock.vue?vue&type=template&id=504325d4&scoped=true"
import script from "./BaseCollapsibleBlock.vue?vue&type=script&lang=js"
export * from "./BaseCollapsibleBlock.vue?vue&type=script&lang=js"
import style0 from "./BaseCollapsibleBlock.vue?vue&type=style&index=0&id=504325d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504325d4",
  null
  
)

export default component.exports